"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = (0, tslib_1.__importStar)(require("react"));
const FileSystem_1 = require("../../FileSystem");
const Row_1 = require("./Row");
const FilesTableContext_1 = require("../FilesTableContext");
const __1 = require("../../");
const useFSContextMenu_1 = require("../../FileSystem/hooks/useFSContextMenu");
const Spinner_1 = require("../../Spinner");
const Body = () => {
    const { onAddToFolder, items, columns, onDoubleClick, loading, disableDrag, disableDrop } = (0, react_1.useContext)(FilesTableContext_1.FilesTableContext);
    const folders = items.filter(item => item.isDirectory);
    const files = items.filter(item => !item.isDirectory && !item.isMasterFile);
    const masterFiles = items.filter(item => item.isMasterFile);
    const rows = [...masterFiles, ...folders, ...files];
    const handleFolderDrop = (0, react_1.useCallback)((items, target) => {
        if (onAddToFolder) {
            onAddToFolder(items, target);
        }
    }, []);
    const { handleItemMouseDown, handleItemClick, setSelected, selectedItems, isSelected, removeSelected } = (0, FileSystem_1.useSelectItems)({
        page: [...folders, ...files]
    });
    const handleClickOutside = (0, react_1.useCallback)(() => {
        setSelected([]);
    }, [setSelected]);
    const tableBodyRef = (0, react_1.useRef)(null);
    const refs = react_1.default.useMemo(() => {
        return Array.from({ length: items.length }, () => react_1.default.createRef());
    }, [items.length]);
    const canSelect = (0, react_1.useCallback)((indexes) => {
        const items = rows
            .filter((item, idx) => indexes.some(index => idx === index))
            .filter(item => isSelected(item));
        return items.length === 0;
    }, [selectedItems.length]);
    const handleSelectionChange = (0, react_1.useCallback)((indexes) => {
        setSelected(rows.filter((i, idx) => indexes.some(index => idx === index)));
    }, [setSelected, rows]);
    const handleDoubleClick = (0, react_1.useCallback)((item) => (event) => {
        if (onDoubleClick)
            onDoubleClick(item, event);
        removeSelected([item]);
    }, [onDoubleClick]);
    const { handleContextMenu } = (0, useFSContextMenu_1.useFSContextMenu)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [tableBodyRef.current && ((0, jsx_runtime_1.jsx)(__1.Selection, { containerRef: tableBodyRef, selectableRefs: refs, onSelectedChange: handleSelectionChange, canSelect: canSelect }, void 0)), loading && (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { delay: 200 }, void 0), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "table__body", ref: tableBodyRef, onContextMenu: event => handleContextMenu(null, event), onClick: handleClickOutside }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "table__body-list" }, { children: rows.map((item, index) => {
                        if (item.isDirectory) {
                            return ((0, jsx_runtime_1.jsx)(FileSystem_1.Folder, Object.assign({ item: item, onDrop: handleFolderDrop, className: "table__row", onMouseDown: handleItemMouseDown(item), onClick: handleItemClick(item), innerRef: refs[index], onDoubleClick: handleDoubleClick(item), disableDrag: disableDrag, disableDrop: disableDrop }, { children: ({ preview, item }) => ((0, jsx_runtime_1.jsx)(Row_1.Row, { selected: isSelected(item), columns: columns, item: item, preview: preview }, void 0)) }), index));
                        }
                        return ((0, jsx_runtime_1.jsx)(FileSystem_1.File, Object.assign({ item: item, className: "table__row", onMouseDown: handleItemMouseDown(item), onClick: handleItemClick(item), innerRef: refs[index], onDoubleClick: handleDoubleClick(item), disableDrag: disableDrag || item.isMasterFile }, { children: ({ preview, item }) => ((0, jsx_runtime_1.jsx)(Row_1.Row, { selected: isSelected(item), columns: columns, item: item, preview: preview }, void 0)) }), index));
                    }) }), void 0) }), void 0)] }, void 0));
};
exports.Body = Body;
//# sourceMappingURL=Body.js.map